<template>
  <section class="clearfix nav-container">
    <div class="main-content-wrap clearfix">
      <div class="logo-container">
        <router-link to="/" @click="changeNav()">
          <img src="../assets/img/logo.png" width="45" height="22"/>
          唯品会·平台规则中心
        </router-link>
      </div>
      <div class="nav-content">
        <ul>
          <li :class="{'active': highLight === 'Index'}">
            <router-link to="/" @click="changeNav()">首页</router-link>
          </li>
          <li v-for="(item, index) in navList" :key="index" :class="{'active': categoryId && categoryId.toString() === item.categoryId.toString()}">
            <router-link router-link :to="{name:'Rule', query:{categoryId: item.categoryId}}" @click="changeNav()">{{item.name}}</router-link>
          </li>
          <li :class="{'active': highLight === 'ViolationPublicity'}">
            <router-link :to="{name: 'ViolationPublicity', query: {type: 1}}" @click="changeNav()">违规公示</router-link>
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
export default {
  name: '',
  data () {
    return {
      localCount: 100
    }
  },
  computed: {
    highLight () {
      if (!this.categoryId || !this.selectCategory) {
        return this.$route.name
      }
      return ''
    },
    selectCategory () {
      return this.navList.find((item) => this.categoryId && this.categoryId.toString() === item.categoryId.toString())
    },
    ...mapState(['navList']),
    ...mapGetters({
      getCount: 'getCount',
      getPage: 'getPage'
    }),
    ...mapState({
      // 箭头函数可使代码更简练
      count: state => state.count,
      // 传字符串参数 'count' 等同于 `state => state.count`
      countAlias: 'count',
      // 为了能够使用 `this` 获取局部状态，必须使用常规函数
      countPlusLocalState (state) {
        return state.count + this.localCount
      },
      categoryId () {
        return this.$store.state.categoryId
      }
    })
  },
  mounted () {
    this.$store.commit('incrementTest')
    // console.log('categoryId', this.$route, this, this.$store.state, this.$store.getters.getCount)
    this.$store.dispatch('increment', 222)
    // console.log('categoryId', this.$route, this, this.$store.state, this.$store.getters.getCount)
    this.increment(2222)
    this.$store.commit('rule/increment')
    // console.log('categoryId', this.$route, this, this.$store.state, this.$store.getters.getCount, this.$store.getters)
    this.getNavs()
  },
  methods: {
    ...mapActions({
      getNavs: 'getNavs',
    }),
    ...mapMutations({
      increment: 'incrementTest'
    }),
    changeNav () {
      this.$emit('changeNav')
    }
  }
}
</script>

<style lang="scss" scoped>
.logo-container {
  float: left;
  font-size: 28px;
  color: #333;
  min-width: 196px;
  line-height: 40px;
  height: 40px;
}
.nav-container {
  min-height: 100px;
  padding-top: 32px;
  box-sizing:border-box;
  background: #FFFFFF;
}
.nav-content {
  float: left;
  ul {
    float: left;
    font-size: 16px;
    color: #333;
    font-weight: 500;
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 90px;
    font-family: \5FAE\8F6F\96C5\9ED1,sans-serif;
    li {
      float: left;
      margin-right: 42px;
      padding: 6px 0;
      border-bottom: 3px solid transparent;
      &:last-child {
        margin-right: 0;
      }
      a {
        color: #333;
      }
      &.active, &:hover {
        a {
          color: #F10180;
        }
        border-bottom: 3px solid #F10180;
      }
    }
  }
}
</style>
